module.exports = __webpack_public_path__ + "assets/monitor1.jpg?31e4251b7281d22d0900616d9a9a9858";